export default __webpack_public_path__ + "static/media/0400.a49b4eee.jpg";